module.exports = __webpack_public_path__ + "static/img/hzgy-bj4.6a14011.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/hzgy-bj4.png
// module id = +rLX
// module chunks = 1